<template>
  <div
    class="icon-action icon-action--filter"
    @click="$emit('click')"
    :class="{ active: isFilterOpened, 'in-use': isFilterActive }"
  >
    <div class="icon-action-icon">
      <svg
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1H1L5.4 6.25556V9.88889L7.6 11V6.25556L12 1Z"
          stroke="#67768A"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="icon-action-text">
      {{ $t('analytics.actions.filter') }}
    </div>
  </div>
</template>

<script>
import FilterIcon from '@js-app/assets/transactions/actions/filter.svg'

export default {
  name: 'ActionsFilterButton',
  props: {
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    isFilterOpened: {
      type: Boolean,
      default: false,
    },
  },
  FILTER_ICON: FilterIcon,
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.icon-action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s linear;
  &-icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 23px;
    height: 23px;
    border-radius: 6px;
    background: rgba(#64748B, 0.2);
    flex-shrink: 0;
    flex-grow: 0;

    &:hover {
      background: rgba(#64748B, 0.2);
    }
  }

  &.in-use & {
    &-icon {
      &:before {
        position: absolute;
        top: -5px;
        right: -5px;
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #dd6262;
      }
    }
  }

  &-text {
    font-weight: 500;
    font-size: 12px;
    line-height: 28px;
    color: #585f6d;
    margin-left: 15px;
    display: none;
  }

  &--filter {
    margin-left: 60px;
  }

  &--sort {
    margin-left: 10px;
  }

  &.active & {
    &-icon {
      background: #64748B;

      svg {
        path {
          stroke: #fff;
        }
      }
    }
  }
}
</style>
